import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicGuarantorNo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M7.68 2.1a1 1 0 01.64 0l5.36 1.8c.2.06.33.24.34.44.34 7.44-3.74 9.53-5.8 10.55a.5.5 0 01-.44 0c-2.06-1.02-6.14-3.11-5.8-10.55.01-.2.15-.38.34-.45zM9.8 5.77a.2.2 0 00-.28 0L8 7.26l-1.5-1.5a.2.2 0 00-.29 0l-.5.5a.2.2 0 000 .28l1.51 1.5L5.8 9.48a.2.2 0 000 .28l.5.5c.07.07.2.07.28 0L8 8.81l1.44 1.43c.07.08.2.08.28 0l.5-.5a.2.2 0 000-.27L8.77 8.04l1.5-1.5a.2.2 0 000-.29z" />
    </svg>
  );
}

SvgBasicGuarantorNo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicGuarantorNo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicGuarantorNo svgRef={ref} {...props} />
));
export default ForwardRef;
